<div class="ir-area ir-mask th-mask">
  <div class="ir-modal th-modal">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [menuComponent]="menuComponent"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-stabilizer">
        <div class="ir-content--modal th-content th-plugin-photo">
          <div class="ir-plugin-photo--fixed">
            <div class="ir-stabilizer">
              <img src="/api/assets/{{ assetId }}/content" alt="" />
            </div>
          </div>
          <div class="ir-carousel th-carousel">
            <div class="ir-stabilizer">
              <div class="ir-carousel-control ir-carousel-control--left" (click)="gotoPrevious()">
                <div class="ir-stabilizer">
                  <i class="material-icons">chevron_left</i>
                </div>
              </div>
              <div class="ir-carousel-image">
                <div class="ir-stabilizer">
                  <img src="https://inspectionreport.blob.core.windows.net/assets/demo/{{ suggestedAssetId }}" alt="" />
                </div>
              </div>

              <div class="ir-carousel-control ir-carousel-control--right" (click)="gotoNext()">
                <div class="ir-stabilizer">
                  <i class="material-icons">chevron_right</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>

<confirm
  #deleteFileConfirm
  (confirmOutput)="deleteFile($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.best-practice.sure-to-delete' | translate"
  [danger]="true"
></confirm>
